module.exports = __webpack_public_path__ + "static/media/corporate1.a4af41ba.jpg";